
export class ParameterConst  {
    public static URL_BASE =  "http://10.51.0.172:4200"; 
    public static TOKEN = "TOKEN";
    public static TOKEN_CLIENTE = "TOKEN_CLIENTE";
    public static USER_LOGIN = "USER";
    public static USER_ROL = "USER_ROL";
    public static USER_MENU = "MENU";
    public static USER_TEMATICS = "TEMATICAS";

    public static CLASS_CSS_SUCCESS = "alert-success";
    public static CLASS_CSS_ERROR = "alert-danger";
    public static CLASS_CSS_INFO = "alert-info";
    public static CLASS_CSS_WARNING = "alert-warning";

    public static MESSAGE_SERFOR = "TIBCARGO Message";
    public static API_DISCONNET = "API Error: sin servicio.";


    //ROLES
    public static MD5_ADMINISTRATOR = "fdee8845ed8040424ad8441341980265";
    public static MD5_RECORDER = "7c91e5456e590143640532c247c0b465";
    public static MD5_RECORDER_ADMINISTRATOR = "f75ab0793c31abed6670319af83b0d6a";
    public static MD5_SHIPPER = "62f8c9f636de722d67a73bc764a198a2";
    public static MD5_DELIVER = "cf37cbd37b3c460c48f2738e6dd598f4";
    public static MD5_SUPERVISOR = "1448b550c6497ee28e8ef90fd1600cd8";


}